import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';
import { MxTableColumn } from 'src/app/shared/domains/common/interfaces';
import { MxColumnType } from 'src/app/shared/enums';
import { MxColumnPositionPipe } from './mx.column-position.pipe';

@Component({ standalone: false,
  selector: 'mx-table-cell',
  templateUrl: './mx.table-cell.component.html',
  styleUrls: ['./mx.table-cell.component.scss'],
})
export class MxTableCellComponent extends MxBaseComponent {
  @Input() column: MxTableColumn;
  @Input() value: any;
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();

  public get columnType(): typeof MxColumnType {
    return MxColumnType;
  }

}
